// About.jsx

import React from "react";
import "./Moving_with_a_lifting_crane.css";
import { Link } from "react-router-dom";







export default function Moving_with_a_lifting_crane() {


  const items = [
    { title: " הובלת חומרי בניין", img: "/images/9.jpeg", path: "/Transportation_of_building_materials"},
    { title: "    הובלת עצים", img: "/images/31.jpeg" , path: "/Transporting_wood"},
    { title: " הובלת ציוד כבד", img: "/images/32.jpeg" , path: "/Transporting_heavy_equipment"},
    { title: "     הובלת מכולות   ", img: "/images/33.jpeg", path: "/Container_Transportation"},
    { title: "   הובלת גנרטורים תעשייתיים כבדים ", img: "/images/12.jpeg", path: "/Transportation_of_industrial_and_heavy_generators"},
    
  ];







  return (

    <div className="Moving_with_a_lifting_crane-page">
      <div className="Moving_with_a_lifting_crane-hero">
        <div className="Moving_with_a_lifting_crane-overlay">
          <h1>      הובלות עם מנוף הרמה</h1>
        </div>

<div>




</div>


</div>

    <div className="page2">




      <div className="grid3">
        {items.map((item, index) => (

           
            <Link to={item.path} key={index} className="card3">

              <img src={item.img} alt={item.title} />

              <div className="card3-btn">
                {item.title}
              </div>

            </Link>
        ))}
      </div>
    </div>


      </div>
  );
}


